import CryptoJS from 'crypto-js';
let SECRET_KEY = 'busbookTicket'
export const encryptText = (text) => {
    return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
};
